import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { Popper, MenuItem } from '@material-ui/core';
export const StyledReorderContainer = styled.div`
  margin-left: auto;
  margin-top: 8px;
`;
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    font-size: 13px;
    line-height: 24px;
    opacity: 0.87;
    fill: ${props => props.isOpen ? '#005099' : '#212121'};
    font-family: 'OpenSans-Regular';
    font-weight: 500;
    text-transform: none;
    padding-right: 0px;
    padding-left: 12px;
  }

  .MuiButton-text {
    padding: 0;
  }

  .MuiButton-label {
    margin: 0px;

    .MuiButton-startIcon {
      margin-right: 8px;
      margin-top: -1px;
    }
  }
`;
export const StyledPopper = styled(Popper)`
  z-index: 2;
  height: 200px;
  overflow: scroll;
  box-shadow: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.13),
    0 0.6px 1.8px 0 rgba(0, 0, 0, 0.11);
  li .MuiCheckbox-colorPrimary.Mui-checked {
    color: #005099 !important;
  }
  li .menu-title {
    font-size: 14px;
    line-height: 40px;
    color: rgba(0, 0, 0, 0.85);
  }
`;
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    width: 100%;
  }
`;
export default {
  StyledButton,
  StyledPopper
};